import { FIRST_QUESTION_LINK_ID_PATH, LINK_ID_SEPERATOR } from '../constants';

export const getTopLevelLinkId = (linkIdPath: string) =>
  linkIdPath?.split(LINK_ID_SEPERATOR)[0] ?? FIRST_QUESTION_LINK_ID_PATH;
